import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import * as XLSX from 'xlsx'; // Import XLSX for Excel export

export default function ListSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjectCount, setSubjectCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(`${apiUrl}/api/auth/login-histrory`, {
        headers: {
          Authorization: token,
        },
      });

      const { loginHistory, count } = response.data;
      setRecords(loginHistory || []);
      setSubjectCount(count || 0);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching records:', error);
      setRecords([]);
      setLoading(false);
      if (error.response?.status === 401) navigate('/');
    }
  };

  const handleExportToExcel = () => {
    const filteredRecords = records.filter((record) =>
      record.LoginTime.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Format the data for Excel
    const data = filteredRecords.map((record, index) => ({
      No: index + 1,
      'Login Date': record.LoginTime.split(' ')[0] || 'N/A',
      'Login Time': (() => {
        const loginTime = record.LoginTime || 'N/A';
        if (loginTime !== 'N/A') {
          const [date, time] = loginTime.split(' ');
          const [hours, minutes] = time.split(':');
          const hour = parseInt(hours, 10);
          const ampm = hour >= 12 ? 'PM' : 'AM';
          const formattedHour = hour % 12 || 12;
          return `${formattedHour}:${minutes} ${ampm}`;
        }
        return loginTime;
      })(),
    }));

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Login History');

    // Trigger download
    XLSX.writeFile(workbook, 'LoginHistory.xlsx');
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Login Date ',
      selector: (row) => row.LoginTime.split(' ')[0] || 'N/A',
      sortable: true,
      center: 'true',
    },
    {
      name: 'Login Time',
      selector: (row) => {
        const loginTime = row.LoginTime || 'N/A';
        if (loginTime !== 'N/A') {
          const [date, time] = loginTime.split(' ');
          const [hours, minutes] = time.split(':');
          const hour = parseInt(hours, 10);
          const ampm = hour >= 12 ? 'PM' : 'AM';
          const formattedHour = hour % 12 || 12;
          return `${formattedHour}:${minutes} ${ampm}`;
        }
        return loginTime;
      },
      sortable: true,
      center: 'true',
    },
  ];

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac1="active">
          <div className="pagetitle ">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  View History ({subjectCount})
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container ">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) =>
                    record.LoginTime.toLowerCase().includes(
                      searchTerm.toLowerCase()
                    )
                  )}
                  progressPending={loading}
                  pagination
                  className="custom-table"
                  paginationPerPage={rowsPerPage} // Set rows per page
                  paginationTotalRows={records.length} // Total number of records
                  paginationDefaultPage={currentPage} // Default starting page
                  onChangePage={(page) => setCurrentPage(page)} // Update current page
                  onChangeRowsPerPage={(newPerPage) =>
                    setRowsPerPage(newPerPage)
                  } // Update rows per page
                />
                <div className="d-flex justify-content-end  mt-3">
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-primary"
                  >
                    <i className="bi bi-arrow-bar-left"></i> Back
                  </button>
                  <button
                    onClick={handleExportToExcel}
                    className="btn btn-primary ms-2"
                  >
                    <i className="bi bi-save"></i> Excel Export
                  </button>
                </div>
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </main>
    </div>
  );
}
